<template>
  <v-app>
    <core-app-bar />

    <core-drawer />

    <core-error-view />

    <core-footer />

  </v-app>
</template>

<script>
export default {
  name: 'Error',

  components: {
    CoreAppBar: () => import('../components/core/AppBar'),
    CoreDrawer: () => import('../components/core/Drawer'),
    CoreErrorView: () => import('../components/core/ErrorView'),
    CoreFooter: () => import('../components/core/Footer'),
  },

  data: () => ({
    expandOnHover: false,
  }),
}
</script>
